// TODO: PXNAV-3722 Remove unwanted constants after AB Test
// TODO:PXNAV-4495 - [FE POD 1] Clean up Sale AB test.
export const saleDepartmentEntranceABTest = {
    EXPERIMENT_FLAG: 'pxnav_sale_entrance_in_burger_menu',
    DEFAULT_VARIABLE: 'variant_type',
    VARIATION_A: 'original',
    VARIATION_B: 'banner_on_top',
    Rea: 'Rea - Upp till 50%',
    Sale: 'Sale - Up to 50%',
    TRIGER_POINT: 'burgerMenuClicked',
    CLICKED: 'clicked',
    NOT_CLICKED: 'notClicked',
};
// TODO:PXNAV-4562 - [FE POD 1] Clean up feature flag 'pxnav_brands_a_to_z_revamp' after gradual roll out.
export const brandsAZRevamp = {
    EXPERIMENT_NAME: 'pxnav_brands_a_to_z_revamp_targeted_delivery',
    EXPERIMENT_FLAG: 'pxnav_brands_a_to_z_revamp',
};
// FEATURE TOGGLING DATA
export const featureFlag = {
    BURGER_MENU_WITH_DPT_IMG: 'pxnav_burger_menu_with_department_images',
    GRID_VARIANT: 'grid',
    CIRCULAR_VARIANT: 'circular',
    DEFAULT_VARIABLE: 'variant',
};
// GENERAL NUMERIC CONSTANTS
export const measurements = {
    GRID_VARIANT_IMAGE_WIDTH: '180',
    CIRCULAR_VARIANT_IMAGE_WIDTH: '150',
    FALLBACK_SCREEN_WIDTH: 767,
};
// CLICK EVENTS
export const clickEvents = {
    CLICK_BURGER_MENU_DPT_LINK_ALL: 'pxnav_click_burger_menu_dpt_link_all',
    CLICK_BURGER_MENU_DPT_LINK_LADIES: 'pxnav_click_burger_menu_dpt_link_women',
    CLICK_BURGER_MENU_DPT_LINK_MEN: 'pxnav_click_burger_menu_dpt_link_men',
    CLICK_BURGER_MENU_DPT_LINK_DIVIDED: 'pxnav_click_burger_menu_dpt_link_divided',
    CLICK_BURGER_MENU_DPT_LINK_KIDS: 'pxnav_click_burger_menu_dpt_link_kids',
    CLICK_BURGER_MENU_DPT_LINK_BABY: 'pxnav_click_burger_menu_dpt_link_baby',
    CLICK_BURGER_MENU_DPT_LINK_HOME: 'pxnav_click_burger_menu_dpt_link_home',
    CLICK_BURGER_MENU_DPT_LINK_BEAUTY: 'pxnav_click_burger_menu_dpt_link_beauty',
    CLICK_BURGER_MENU_DPT_LINK_BRANDS: 'pxnav_click_burger_menu_dpt_link_brands',
    CLICK_BURGER_MENU_DPT_LINK_SPORT: 'pxnav_click_burger_menu_dpt_link_sport',
    CLICK_BURGER_MENU_DPT_LINK_SALE: 'pxnav_click_burger_menu_dpt_link_sale',
    CLICK_BURGER_MENU_DPT_LINK_NON_SALE: 'pxnav_click_burger_menu_dpt_non_sale',
    CLICK_BURGER_MENU_OPEN_FROM_SALE: 'pxnav_click_open_burger_menu_dpt_sale',
    CLICK_BURGER_MENU_OPEN_FROM_NON_SALE: 'pxnav_click_open_burger_menu_dpt_non_sale',
    CLICK_ARROW_BACK_BUTTON_FROM_SALE: 'pxnav_click_arrow_back_button_dpt_sale',
    CLICK_LADIES_PDP_ATB: 'pxnav_click_ladies_pdp_atb',
    CLICK_MEN_PDP_ATB: 'pxnav_click_men_pdp_atb',
    CLICK_KIDS_PDP_ATB: 'pxnav_click_kids_pdp_atb',
    CLICK_HOME_PDP_ATB: 'pxnav_click_home_pdp_atb',
    CLICK_BEAUTY_PDP_ATB: 'pxnav_click_beauty_pdp_atb',
    CLICK_SPORT_PDP_ATB: 'pxnav_click_sport_pdp_atb',
    CLICK_BABY_PDP_ATB: 'pxnav_click_baby_pdp_atb',
    CLICK_BRANDS_PDP_ATB: 'pxnav_click_brands_pdp_atb',
    CLICK_SALE_PDP_ATB: 'pxnav_click_sale_pdp_atb',
    CLICK_NON_SALE_PDP_ATB: 'pxnav_click_non_sale_pdp_atb',
};
// VISIT PAGE EVENTS
export const pageVisitPlpEvents = {
    VISIT_PAGE_PLP_ALL: 'pxnav_visit_page_plp_all',
    VISIT_PAGE_PLP_BEAUTY: 'pxnav_visit_page_plp_beauty',
    VISIT_PAGE_PLP_LADIES: 'pxnav_visit_page_plp_ladies',
    VISIT_PAGE_PLP_MEN: 'pxnav_visit_page_plp_men',
    VISIT_PAGE_PLP_DIVIDED: 'pxnav_visit_page_plp_divided',
    VISIT_PAGE_PLP_KIDS: 'pxnav_visit_page_plp_kids',
    VISIT_PAGE_PLP_BABY: 'pxnav_visit_page_plp_baby',
    VISIT_PAGE_PLP_HOME: 'pxnav_visit_page_plp_home',
    VISIT_PAGE_PLP_BRANDS: 'pxnav_visit_page_plp_brands',
    VISIT_PAGE_PLP_SPORT: 'pxnav_visit_page_plp_sport',
    VISIT_PAGE_PLP_SALE: 'pxnav_visit_page_plp_sale',
    VISIT_PAGE_PLP_NON_SALE: 'pxnav_visit_page_dpt_plp_non_sale',
    VISIT_PAGE_PLP_SALE_LADIES: 'pxnav_visit_page_plp_sale_ladies',
    VISIT_PAGE_PLP_SALE_DIVIDED: 'pxnav_visit_page_plp_sale_divided',
    VISIT_PAGE_PLP_SALE_MEN: 'pxnav_visit_page_plp_sale_men',
    VISIT_PAGE_PLP_SALE_KIDS: 'pxnav_visit_page_plp_sale_kids',
    VISIT_PAGE_PLP_SALE_BABY: 'pxnav_visit_page_plp_sale_baby',
    VISIT_PAGE_PLP_SALE_HOME: 'pxnav_visit_page_plp_sale_home',
    VISIT_PAGE_PLP_SALE_BEAUTY: 'pxnav_visit_page_plp_sale_beauty',
    VISIT_PAGE_PLP_SALE_SPORT: 'pxnav_visit_page_plp_sale_sport',
    VISIT_PAGE_PLP_SALE_BRANDS: 'pxnav_visit_page_plp_sale_brands',
};
// VISIT PAGE EVENTS
export const pageVisitPdpEvents = {
    VISIT_PAGE_PDP_ALL: 'pxnav_visit_page_pdp_all',
    VISIT_PAGE_PDP_LADIES: 'pxnav_visit_page_pdp_ladies',
    VISIT_PAGE_PDP_MEN: 'pxnav_visit_page_pdp_men',
    VISIT_PAGE_PDP_KIDS: 'pxnav_visit_page_pdp_kids',
    VISIT_PAGE_PDP_HOME: 'pxnav_visit_page_pdp_home',
    VISIT_PAGE_PDP_BEAUTY: 'pxnav_visit_page_pdp_beauty',
    VISIT_PAGE_PDP_SPORT: 'pxnav_visit_page_pdp_sport',
    VISIT_PAGE_PDP_BRANDS: 'pxnav_visit_page_pdp_brands',
    VISIT_PAGE_PDP_SALE: 'pxnav_visit_page_pdp_sale',
    VISIT_PAGE_PDP_NON_SALE: 'pxnav_visit_page_pdp_non_sale',
};
// REGULAR EXPRESSION FOR PLP
// NEW ARRIVAL TEST
export const regExpPlpUrl = {
    sv_se: {
        womenPlp: /\/sv_se\/dam\//,
        menPlp: /\/sv_se\/herr\//,
        dividedPlp: /\/sv_se\/divided\//,
        babyPlp: /\/sv_se\/baby\//,
        kidsPlp: /\/sv_se\/barn\//,
        beautyPlp: /\/sv_se\/beauty\//,
        sportPlp: /\/sv_se\/sport\//,
        homePlp: /\/sv_se\/home\//,
        brandPlp: /\/sv_se\/.*\/brands\//,
        salePlp: /\/sv_se\/rea\//,
        // TODO:PXNAV-4451 - [FE POD 1] Clean up New Arrival AB test.
        womenPlpNewArrivals: /\/sv_se\/dam\/nyheter\//,
        womenPlpNewArrivalsClothing: /\/sv_se\/dam\/nyheter\/klader.html/,
        womenPlpNewArrivalsShoesAccessories: /\/sv_se\/dam\/nyheter\/skor-accessoarer.html/,
        womenPlpNewArrivalsUnderWearSleepWear: /\/sv_se\/dam\/nyheter\/underklader-sovplagg.html/,
        womenPlpNewArrivalsBeauty: /\/sv_se\/beauty\/nyheter\/se-alla.html/,
        womenPlpNewArrivalsSeeAll: /\/sv_se\/dam\/nyheter\/se-alla.html/,
    },
    en_us: {
        womenPlp: /\/en_us\/women\//,
        menPlp: /\/en_us\/men\//,
        dividedPlp: /\/en_us\/divided\//,
        babyPlp: /\/en_us\/baby\//,
        kidsPlp: /\/en_us\/kids\//,
        beautyPlp: /\/en_us\/beauty\//,
        sportPlp: /\/en_us\/sport\//,
        homePlp: /\/en_us\/home\//,
        brandPlp: /\/en_us\/.*\/brands\//,
        salePlp: /\/en_us\/sale\//,
        // TODO:PXNAV-4451 - [FE POD 1] Clean up New Arrival AB test.
        womenPlpNewArrivals: /\/en_us\/women\/new-arrivals\//,
        womenPlpNewArrivalsClothing: /\/en_us\/women\/new-arrivals\/clothes.html/,
        womenPlpNewArrivalsShoesAccessories: /\/en_us\/women\/new-arrivals\/shoes-accessories.html/,
        womenPlpNewArrivalsUnderWearSleepWear: /\/en_us\/women\/new-arrivals\/underwear-nightwear.html/,
        womenPlpNewArrivalsBeauty: /\/en_us\/women\/new-arrivals\/beauty.html/,
        womenPlpNewArrivalsSeeAll: /\/en_us\/women\/new-arrivals\/view-all.html/,
    },
    en_gb: {
        womenPlp: /\/en_gb\/ladies\//,
        womenPlpSport: /\/en_gb\/sport\/ladies\//,
        menPlp: /\/en_gb\/men\//,
        dividedPlp: /\/en_gb\/divided\//,
        babyPlp: /\/en_gb\/baby\//,
        kidsPlp: /\/en_gb\/kids\//,
        beautyPlp: /\/en_gb\/beauty\//,
        sportPlp: /\/en_gb\/sport\//,
        homePlp: /\/en_gb\/home\//,
        brandPlp: /\/en_gb\/.*\/brands\//,
        salePlp: /\/en_gb\/sale\//,
        // TODO:PXNAV-4451 - [FE POD 1] Clean up New Arrival AB test.
        womenPlpNewArrivals: /\/en_gb\/ladies\/new-arrivals\//,
        womenPlpNewArrivalsClothing: /\/en_gb\/ladies\/new-arrivals\/clothes.html/,
        womenPlpNewArrivalsShoesAccessories: /\/en_gb\/ladies\/new-arrivals\/shoes-and-accessories.html/,
        womenPlpNewArrivalsUnderWearSleepWear: /\/en_gb\/ladies\/new-arrivals\/underwear-nightwear.html/,
        womenPlpNewArrivalsBeauty: /\/en_gb\/ladies\/new-arrivals\/beauty.html/,
        womenPlpNewArrivalsSeeAll: /\/en_gb\/ladies\/new-arrivals\/view-all.html/,
        womenPlpNewArrivalsSports: /\/en_gb\/sport\/ladies\/new-arrivals.html/,
    },
};
export const regExpUrlsSweden = {
    womenPlp: /\/sv_se\/dam\//,
    menPlp: /\/sv_se\/herr\//,
    dividedPlp: /\/sv_se\/divided\//,
    babyPlp: /\/sv_se\/baby\//,
    kidsPlp: /\/sv_se\/barn\//,
    beautyPlp: /\/sv_se\/beauty\//,
    sportPlp: /\/sv_se\/sport\//,
    homePlp: /\/sv_se\/home\//,
    brandPlp: /\/sv_se\/.*\/brands\//,
    brandsSvPlp: /\/sv_se\/.*\/varumarken\//,
    brandsAZSe: /\/sv_se\/.*\/brands\/marken.html/,
    brandsAZEn: /\/sv_se\/.*\/brands\/brands-a-z.html/,
    brandsAZ: /\/sv_se\/brands.html/,
    salePlp: /\/sv_se\/rea\//,
};
export const regExpUrlsUk = {
    womenPlp: /\/en_gb\/ladies\//,
    menPlp: /\/en_gb\/men\//,
    dividedPlp: /\/en_gb\/divided\//,
    babyPlp: /\/en_gb\/baby\//,
    kidsPlp: /\/en_gb\/kids\//,
    beautyPlp: /\/en_gb\/beauty\//,
    sportPlp: /\/en_gb\/sport\//,
    homePlp: /\/en_gb\/home\//,
    brandPlp: /\/en_gb\/.*\/brands\//,
    brandsAZEn: /\/en_gb\/.*\/brands\/brands-a-z.html/,
    brandsAZ: /\/en_gb\/brands.html/,
    salePlp: /\/en_gb\/sale\//,
};
export const regExpUrlsSwedenSale = {
    womenPlpSale: /\/sv_se\/rea\/dam\//,
    menPlpSale: /\/sv_se\/rea\/herr\//,
    dividedPlpSale: /\/sv_se\/rea\/shopbyproductdivided\//,
    babyPlpSale: /\/sv_se\/rea\/baby\//,
    kidsPlpSale: /\/sv_se\/rea\/barn\//,
    beautyPlpSale: /\/sv_se\/rea\/dam\/beauty.html/,
    sportPlpSale: /\/sv_se\/rea\/sport\//,
    homePlpSale: /\/sv_se\/rea\/home\//,
    brandsPlpSale: /\/sv_se\/rea\/brands\//,
    brandsAZSe: /\/sv_se\/.*\/brands\/marken.html/,
    brandsAZEn: /\/sv_se\/.*\/brands\/brands-a-z.html/,
    brandsAZ: /\/sv_se\/brands.html/,
};
export const regExpUrlsUkSale = {
    womenPlpSale: /\/en_gb\/sale\/ladies\//,
    menPlpSale: /\/en_gb\/sale\/men\//,
    dividedPlpSale: /\/en_gb\/sale\/divided\//,
    babyPlpSale: /\/en_gb\/sale\/baby\//,
    kidsPlpSale: /\/en_gb\/sale\/kids\//,
    beautyPlpSale: /\/en_gb\/sale\/ladies\/beauty.html/,
    sportPlpSale: /\/en_gb\/sale\/sport\//,
    homePlpSale: /\/en_gb\/sale\/home\//,
    brandsPlpSale: /\/en_gb\/sale\/brands\//,
    brandsAZ: /\/en_gb\/brands.html/,
};
// REGULAR EXPRESSION FOR BRANDS A TO Z PAGE
// REGULAR EXPRESSION FOR BRANDS A TO Z PAGE
export const brandAZPageRegExp = {
    sv_se: {
        brandsAZSv: /\/sv_se\/.*\/brands\/marken.html/,
        brandsAZEn: /\/sv_se\/.*\/brands\/brands-a-z.html/,
        brandsAZ: /\/sv_se\/brands.html/,
        index: /\/sv_se\/index.html/,
    },
    en_gb: {
        brandsAZ: /\/en_gb\/.*\/brands\/brands.html/,
        brandsAZEn: /\/en_gb\/.*\/brands\/brands-a-z.html/,
        index: /\/en_gb\/index.html/,
    },
};
// REGULAR EXPRESSION FOR PDP UTAG DATA
export const regExpPdp = {
    pdpSE: /\/sv_se\/productpage/,
    pdpUK: /\/en_gb\/productpage/,
    womenPdp: /ladies/,
    menPdp: /men/,
    kidsPdp: /kids/,
    babyPdp: /baby/,
    beautyPdp: /beauty/,
    brandsPdp: /brands/,
    homePdp: /home/,
    sportPdp: /sport/,
    salePdp: /rea/,
};
// SEGMENTS DATA
export const segments = {
    hasClickedBabyDepartment: false,
    hasClickedBeautyDepartment: false,
    hasClickedDividedDepartment: false,
    hasClickedHomeDepartment: false,
    hasClickedKidsDepartment: false,
    hasClickedLadiesDepartment: false,
    hasClickedMensDepartment: false,
};
// SEGMENTS DATA MAPPING
export const segmentsMap = {
    pxnav_click_burger_menu_dpt_link_women: 'hasClickedLadiesDepartment',
    pxnav_click_burger_menu_dpt_link_men: 'hasClickedMensDepartment',
    pxnav_click_burger_menu_dpt_link_divided: 'hasClickedDividedDepartment',
    pxnav_click_burger_menu_dpt_link_kids: 'hasClickedKidsDepartment',
    pxnav_click_burger_menu_dpt_link_baby: 'hasClickedBabyDepartment',
    pxnav_click_burger_menu_dpt_link_home: 'hasClickedHomeDepartment',
    pxnav_click_burger_menu_dpt_link_beauty: 'hasClickedBeautyDepartment',
};
// Checkout routes
export const CART_URL = 'cart';
export const CHECKOUT_LOGIN_URL = 'login/checkout';
export const INDEX_URL = 'index.html';
//# sourceMappingURL=constants.js.map